import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { EXECUTION } from '../../../constants/execution-modes';
import { ERROR } from '../../../constants/routes';

export const ResultsRoute = ({ children, executionMode, finished, ...rest }) => {
    if (!finished || executionMode !== EXECUTION) {
        return (
            <Navigate
                to={{
                    pathname: ERROR,
                }}
            />
        );
    }
    return children;
};

ResultsRoute.propTypes = {
    children: PropTypes.node,
    executionMode: PropTypes.string,
    finished: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        finished: state.status.finished,
        executionMode: state.application.executionMode,
    };
};

export default connect(mapStateToProps)(ResultsRoute);
